import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Dynamic',
    name: 'Dynamic',
    component: () => import('../views/Dynamic.vue')
  },
  {
    path: '/DynamicDetail',
    name: 'DynamicDetail',
    component: () => import('../views/DynamicDetail.vue')
  },
  {
    path: '/Industry',
    name: 'Industry',
    component: () => import('../views/Industry.vue')
  },
  {
    path: '/IndustryDetail',
    name: 'IndustryDetail',
    component: () => import('../views/IndustryDetail.vue')
  },
  {
    path: '/Products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('../views/Solutions.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/Support.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.afterEach((to) => {
  if (to.hash) {
    // 只获取锚点部分，不包含查询参数
    const hash = to.hash.split('?')[ 0 ]
    setTimeout(() => {
      const element = document.querySelector(hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)
  }
});
// 解决重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    // 只忽略重复导航的错误
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}
export default router
